module.exports = __webpack_public_path__ + "static/media/side_banner.e63769da.png";